module.exports = __webpack_public_path__ + "img/partners-fintree.9091234d.png";